import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../api';
import { inject } from '@angular/core';
import { map } from 'rxjs';

export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService)
  return authService.isAuthenticated.pipe(map(isAuth => !isAuth))
};
